
const _ = require('lodash');


module.exports = function Server (options) {
	_.extend(this, _.mapValues(options.hosts, _.bind(function (hostConstructor) {
		return new hostConstructor({}, this);
	}, this)));

	this._config = options.config;
};

